import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { LogsState, LOGS_SLICE_NAME } from './models';

export const logsSelector = (state: RootState): LogsState => state[LOGS_SLICE_NAME];

export const selectLogsIsLoading = createSelector(logsSelector, (state: LogsState) => state.isLoading);

export const selectActionLogs = createSelector(logsSelector, (state: LogsState) => state.actionLogs);

export const selectPagination = createSelector(logsSelector, (state: LogsState) => state.pagination);

export const selectLogsError = createSelector(logsSelector, (state: LogsState) => state.error);
